/** @format */
import {
	maxFileSize,
	maxLength,
	mimes,
	minEventDate,
	maxEventDate,
	mobile,
	required,
	persianString,
	dateFormat,
	isValidNatCode,
} from './Rules/Rules';
import moment from 'jalali-moment';

const getMessage = () => {
	return {
		required: '%s الزامی است',
		mimes: 'فرمت %s باید %d باشد',
		maxFileSize: 'حجم %s نمیتواند بیشتر از %d باشد',
		maxLength: '%s نباید بیشتر از %d کاراکتر باشد',
		persianString: 'تنها مجاز به وارد کردن حروف فارسی هستید',
		mobile: ' موبایل وارد شده اشتباه است موبایل 11 رقم و با 0 شروع میشود',
		date: 'لطفا تاریخ تولد خود را به درستی وارد کنید',
		minEventDate: '%s نمی تواند کوچکتر از %d باشد',
		maxEventDate: '%s نمی تواند بزرگتر از از %d باشد',
		nat_code: '%s اشتباه است',
	};
};

const validate = (fields, errors, setErrors, currentEvent) => {
	let messages = {};
	let hasNotError = true;
	fields?.forEach((field) => {
		if (
			field?.validation?.required !== undefined &&
			field?.validation?.required
		) {
			if (!required(field)) {
				messages[field.name] = getMessage().required.replace('%s', field.label);
				hasNotError = false;
			}
		}

		if (field.validation?.mimes !== undefined) {
			if (!mimes(field)) {
				let message = getMessage().mimes.replace('%s', field.label);
				messages[field.name] = message.replace('%d', field.validation.mimes);

				hasNotError = false;
			}
		}
		if (field.validation?.max_file_size !== undefined) {
			if (!maxFileSize(field)) {
				let message = getMessage().maxFileSize.replace('%s', field.label);
				messages[field.name] = message.replace(
					'%d',
					field.validation.max_file_size + 'KB',
				);

				hasNotError = false;
			}
		}

		if (field.validation?.max_length !== undefined) {
			if (!maxLength(field)) {
				let message = getMessage().maxLength.replace('%s', field.label);
				messages[field.name] = message.replace(
					'%d',
					field.validation.max_length,
				);

				hasNotError = false;
			}
		}

		if (
			field.validation?.persian_string !== undefined &&
			field.validation?.persian_string
		) {
			if (!persianString(field)) {
				messages[field.name] = getMessage().persianString;
				hasNotError = false;
			}
		}
		if (field.validation?.mobile !== undefined && field.validation?.mobile) {
			if (!mobile(field)) {
				messages[field.name] = getMessage().mobile;
				hasNotError = false;
			}
		}
		if (field.validation?.date !== undefined && field.validation?.date) {
			if (!dateFormat(field)) {
				messages[field.name] = getMessage().date;
				hasNotError = false;
			}
		}

		if (
			field?.validation?.minEventDate !== undefined &&
			field?.validation?.minEventDate
		) {
			if (!minEventDate(field, currentEvent.start_register_date)) {
				let message = getMessage().minEventDate.replace('%s', field.label);
				messages[field.name] = message.replace(
					'%d',
					moment(currentEvent.start_register_date ?? '2000,01,01', 'YYYY/MM/DD')
						.locale('fa')
						.format('YYYY/MM/DD'),
				);
				hasNotError = false;
			}
		}
		if (
			field?.validation?.maxEventDate !== undefined &&
			field?.validation?.maxEventDate
		) {
			if (!maxEventDate(field, currentEvent.end_register_date)) {
				let message = getMessage().maxEventDate.replace('%s', field.label);
				messages[field.name] = message.replace(
					'%d',
					moment(currentEvent.end_register_date ?? '2000,01,01', 'YYYY/MM/DD')
						.locale('fa')
						.format('YYYY/MM/DD'),
				);
				hasNotError = false;
			}
		}

		if (
			field?.validation?.nat_code !== undefined &&
			field?.validation?.nat_code
		) {
			if (!isValidNatCode(field)) {
				messages[field.name] = getMessage().nat_code.replace('%s', field.label);
				hasNotError = false;
			}
		}
	});
	setErrors(messages);
	return hasNotError;
};

let validations = {
	validate: (fields, errors, setErrors, currentEvent) =>
		validate(fields, errors, setErrors, currentEvent),
};

export default validations;
